<template>
    <div class="temp-content-action">
      <t-form>
        <!--基础信息-->
        <div class="base-info-wrap">
            <div class="section-title">基础信息</div>

            <!--营地名称-->
            <div class="form-item">
                <div class="form-item-title">
                    <span class="require-symbol">*</span>
                    营地名称
                </div>

                <div class="form-element">
                    <t-input
                        v-model="formData.name"
                        placeholder="请输入营地名称"
                        :maxlength="32"
                        show-limit-number
                        clearable
                        size="large"
                    />
                </div>
            </div>

            <!--营地类型-->
            <div class="form-item">
                <div class="form-item-title">
                    <span class="require-symbol">*</span>
                    营地类型
                </div>
                <div class="form-element">
                    <t-select
                        v-model="formData.campType"
                        :options="campTypeOption"
                        filterable
                        multiple
                        clearable
                        placeholder="请选择营地类型"
                        size="large"
                    />
                </div>
            </div>
            
            <!--营地位置-->
            <div class="form-item">
                <div class="form-item-title">
                    <span class="require-symbol">*</span>
                    营地位置
                </div>

                <div class="form-element">
                    <t-input
                      v-model="formData.location"
                      placeholder="请输入经纬度"
                      show-limit-number
                      clearable
                      size="large"
                    />

                    <div class="tip-desc" >
                        请复制坐标后填入
                        <div class="tip-desc-url" @click="openMapPicker">
                          复制坐标
                        </div>
                    </div>
                </div>
            </div>


            <!--开放日期-->
            <div class="form-item">
                <div class="form-item-title">
                    <span class="require-symbol">*</span>
                    开放日期
                </div>
                <div class="form-element">
                    <t-select
                      v-model="formData.openDate"
                      :options="openDateOption"
                      filterable
                      multiple
                      clearable
                      placeholder="请选择日期"
                      size="large"
                    />
                </div>
            </div>
            
            <!--营业时间-->
            <div class="form-item">
                <div class="form-item-title">
                  <span class="require-symbol">*</span>
                    营业时间
                </div>

                <div class="form-element">
                    <t-time-range-picker
                      v-model="formData.openTime"
                      format="HH:mm"
                      allowInput
                      clearable
                      size="large"
                    />
                </div>
            </div>

            <!--营地价格-->
            <div class="form-item">
                <div class="form-item-title">
                    <span class="require-symbol">*</span>
                    营地价格
                </div>

                <div class="form-element">
                    <t-input
                      v-model="formData.price"
                      type="number"
                      placeholder="请输入价格"
                      show-limit-number
                      clearable
                      size="large"
                    />

                    <div class="form-add">
                        <t-textarea
                            v-model="formData.priceDesc"
                            placeholder="请输入价格说明"
                            :maxlength="descMaxLength"
                            show-limit-number
                            clearable
                            size="large"
                        />
                    </div>
                </div>

                
            </div>

            <!--联系电话-->
            <div class="form-item">
                <div class="form-item-title">
                    联系电话
                </div>

                <div class="form-element">
                    <t-input
                        v-model="formData.phone"
                        placeholder="请输入联系电话"
                        :maxlength="16"
                        show-limit-number
                        clearable
                        size="large"
                    />
                </div>
            </div>

            <!--实地认证-->
            <div class="form-item">
                <div class="form-item-title">实地认证</div>
                <div class="form-element">
                    <t-radio-group
                        class="radio-group"
                        v-model="formData.isOnSite"
                    >
                        <t-radio :value="true">是</t-radio>
                        <t-radio :value="false">否</t-radio>
                    </t-radio-group>                  
                </div>
            </div>

            <!--营地标签-->
            <div class="form-item">
                  <div class="form-item-title"> 营地标签</div>
                  <!--营地标签选项-->
                  <div class="form-element">
                      <t-checkbox-group v-model="formData.campTag" size="large">
                          <t-checkbox v-for="tag in campTag" :key="tag.value" :value="tag.value">
                              {{ tag.label }}
                          </t-checkbox>
                      </t-checkbox-group>
                  </div>
            </div>

      </div>
        
        <!--营地图片信息-->
        <div class="camp-image-info-wrap">
            <div class="section-title">
                营地图片信息
            </div>

            <div class="form-item">
                <div class="form-item-title">
                    <span class="require-symbol">*</span>
                    上传图片
                </div>
                <div>
                    <t-upload
                      v-model="formData.image"
                      theme="image"
                      accept="image/*"
                      :auto-upload="false"
                      :showImageFileName="false"
                      multiple
                      :max="30"
                      :size-limit="sizeLimit"
                      tips="最大不超过10M，最多上传30张"
                      @success="onUploadSuccess"
                      @fail="onUploadFail"
                      :beforeUpload="beforeUpload"
                    />
                </div>
            </div>
        </div>

        <!--营地评分信息-->
        <div class="camp-tag-wrap">
              <div class="section-title">营地评分信息</div>

              <!--营地环境评分-->
              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      营地环境
                  </div>

                  <div class="form-element">
                      <t-input
                        v-model="formData.envRate"
                        type="number"
                        placeholder="请输入营地环境评分"
                        suffix="分"
                        clearable
                        size="large"
                      />
                  </div>

                  
              </div>

              <!--营地设施评分-->
              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      营地设施
                  </div>

                  <div class="form-element">
                      <t-input
                        v-model="formData.facilityRate"
                        type="number"
                        placeholder="请输入营地设施评分"                   
                        suffix="分"
                        clearable
                        size="large"
                      />
                  </div> 
              </div>

              <!--营地体验评分-->
              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      营地体验
                  </div>

                  <div class="form-element">
                      <t-input
                        v-model="formData.experienceRate"
                        type="number"
                        placeholder="请输入营地体验评分"
                        suffix="分"
                        clearable
                        size="large"
                      />
                  </div> 
              </div>

              <div class="form-item">
                  <div class="form-item-title">
                      营地总分
                  </div>

                  <div class="rate-text">
                      {{ totalRate }}
                  </div> 
              </div>

              
        </div>

        <!--营地设施信息-->
        <div class="camp-facility-info-wrap">
            <div class="section-title">营地设施信息</div>

            <template v-for="(facilityGroup, groupName) in groupedFacility" :key="groupName">
                <!--设施组标题-->
                <div class="sub-title">{{ groupName }} ({{ facilityGroup.length }})</div>

                <!--设施选项-->
                <template v-for="facility in facilityGroup" :key="facility.id">
                    <div class="form-item">
                        <div class="form-item-title">
                            <span v-if="facility.is_required" class="require-symbol">*</span>
                            {{ facility.title }}
                        </div>
                        <div class="form-element">
                            <t-select
                              v-model="formData.facility[facility.title]"
                              :options="facility.options.split(',').map(option => ({ label: option, value: option }))"
                              :multiple="facility.option_type === '2'"
                              filterable
                              clearable
                              placeholder="请选择"
                              size="large"
                            />
                            <div v-if="facility.is_desc" class="form-add">
                                <t-input
                                  v-model="formData.facility[facility.title + '_desc']"
                                  placeholder="请输入补充说明"
                                  :maxlength="descMaxLength"
                                  show-limit-number
                                  clearable
                                  size="large"
                                />
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </div>    
      </t-form>
    </div>

    <action-bar 
        :confirm-text="'确定'"
        :cancel-text="'取消'"
        @confirm="submitForm"
        @cancel="handleCancel"
        :loading="submitting"
    />
</template>


<script setup>
    import { ref, reactive, onMounted, computed, watch } from 'vue';
    import actionBar from '../../../components/action-bar/action-bar.vue';
    import campAPI from '../../../api/camp-api';
    import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
    import { useRouter, useRoute } from 'vue-router';

    //获取 router 实例
    const router = useRouter();
    const route = useRoute();

    // 提交状态
    const submitting = ref(false);

    /**
     * 初始化数据
     */

    // 初始化表单
    const formData = reactive({
        name: '',
        campType: [],
        location: '', 
        latitude: '', // 纬度字段
        longitude: '', // 经度字段
        openDate: [],
        openTime: ['09:00', '18:00'],
        price:'',
        priceDesc:'',
        phone:'',
        isOnSite: false,
        isActive: true,
        campTag: [],
        rate: '',
        envRate: '',
        facilityRate: '',
        experienceRate: '',
        image: [],
        facility: {},
        existingImage: []
    });

    // 初始化营地类型
    const campTypeOption = ref([]);
    // 初始化营地标签
    const campTag = ref([]);
    // 初始化营地设施
    const facilityList = ref([]);


    /**
     * 分隔经纬度函数
     */
     const handleLocation = (value) => {
        const [longitude, latitude] = value.split(',').map(coord => coord.trim());
        formData.longitude = longitude; // 经度
        formData.latitude = latitude;   // 纬度
    };
    
    watch(() => formData.location, (newValue) => {
        handleLocation(newValue); 
    });

    

    /**
     * 获取营地类型
     */
    const getCampType = async () => {
        try {
            const types = await campAPI.getCampType();
            campTypeOption.value = types.map(type => ({
                label: type.name,
                value: type.id
            }));
        } catch (error) {
            console.error('获取营地类型失败:', error);
            MessagePlugin.error('获取营地类型失败，请重试');
        }
    };

    /**
     * 获取营地标签
     */
    const getCampTag = async () => {
        try {
          const response = await campAPI.getCampTag();
          campTag.value = response.map(tag => ({
            label: tag.name,
            value: tag.id
          }));
        } catch (error) {
          console.error('获取营地标签失败:', error);
          MessagePlugin.error('获取营地标签失败');
        }
    };

    /**
     * 计算总评分
     */
    const totalRate = computed(() => {
        const env = parseFloat(formData.envRate);
        const facility = parseFloat(formData.facilityRate);
        const experience = parseFloat(formData.experienceRate);
        
        if (isNaN(env) || isNaN(facility) || isNaN(experience)) {
            return '--';
        }
        
        const total = (env + facility + experience) / 3;
        return total.toFixed(1);
    });

    watch([() => formData.envRate, () => formData.facilityRate, () => formData.experienceRate], 
      ([newEnvRate, newFacilityRate, newExperienceRate]) => {
        if (newEnvRate && newFacilityRate && newExperienceRate) {
          const total = (parseFloat(newEnvRate) + parseFloat(newFacilityRate) + parseFloat(newExperienceRate)) / 3;
          formData.rate = total.toFixed(1);
        } else {
          formData.rate = '';
        }
      }
    );

    /**
     * 获取营地设施选项
     */
     const getFacility = async () => {
        try {
          const allFacility = await campAPI.getFacility();
          facilityList.value = allFacility.filter(f => f.is_active);
          initializeFacilityForm();
        } catch (error) {
          console.error('获取设施失败:', error);
        }
    };

    const initializeFacilityForm = () => {
          facilityList.value.forEach(facility => {
            if (!formData.facility.hasOwnProperty(facility.title)) {
              if (facility.option_type === '2') {
                formData.facility[facility.title] = [];
              } else {
                formData.facility[facility.title] = '';
              }
            }
            if (facility.is_desc && !formData.facility.hasOwnProperty(facility.title + '_desc')) {
              formData.facility[facility.title + '_desc'] = '';
            }
          });
    };

    /**
     * 加载表单数据
     */
    const loadCampData = async (id) => {
        try {
            const campData = await campAPI.getCampDetail(id);
            console.log('API返回的营地数据:', campData);
            
            // 基本信息
            formData.name = campData.name;
            formData.price = campData.price;
            formData.openDate = campData.open_date ? campData.open_date.split(',') : [];
            formData.openTime = [campData.start_time, campData.end_time];
            // 位置信息
            formData.location = `${campData.longitude},${campData.latitude}`;
            formData.latitude = campData.latitude;
            formData.longitude = campData.longitude;

            formData.phone = campData.phone || '';
            formData.priceDesc = campData.price_desc || '';
            formData.isOnSite = campData.is_on_site;
            formData.isActive = campData.is_active;
            
            // 营地类型
            formData.campType = campData.camp_type.map(type => type.id);

            // 营地标签
            formData.campTag = campData.tags.map(tag => tag.id);

            // 图片数据
            if (campData.image && campData.image.length > 0) {
                formData.image = campData.image.map(img => ({
                    url: img.image_url,
                    name: img.image_url.split('/').pop(),
                    status: 'success',
                    id: img.id
                }));
                formData.existingImage = campData.image.map(img => img.image_url);
                } else {
                formData.image = [];
                formData.existingImage = [];
            }

            // 营地评分
            formData.envRate = campData.env_rate || '';
            formData.facilityRate = campData.facility_rate || '';
            formData.experienceRate = campData.experience_rate || '';

            // 设施数据
            formData.facility = {};
            if (Array.isArray(campData.facility)) {
                campData.facility.forEach(facility => {
                    const facilityInfo = facilityList.value.find(f => f.id === facility.facility_id);
                    if (facilityInfo) {
                        if (facilityInfo.option_type === '2') { // 多选
                            formData.facility[facilityInfo.title] = facility.facility_content.split(',');
                        } else { // 单选或文本
                            formData.facility[facilityInfo.title] = facility.facility_content;
                        }
                        if (facility.facility_desc) {
                            formData.facility[facilityInfo.title + '_desc'] = facility.facility_desc;
                        }
                    }
                });
            }

          console.log('加载的营地数据:', formData);
        } catch (error) {
          console.error('加载营地数据失败:', error);
          MessagePlugin.error('加载营地数据失败，请重试');
        }
    };

    onMounted(async () => {
        await getCampType(); // 获取营地类型
        await getCampTag(); // 获取营地标签
        await getFacility(); // 获取设施数据
        const campId = route.params.id;
        if (campId) {
          await loadCampData(campId);
        }
    });

    /**
     * 计按组名分组设施选项
     */
     const groupedFacility = computed(() => {
        const group = {};
        facilityList.value.forEach(facility => {
          if (!group[facility.group_name]) {
            group[facility.group_name] = [];
          }
          group[facility.group_name].push(facility);
        });
        return group;
    });

    /**
     * 上传图片
     */

    // 上传图片前验证
    const beforeUpload = (file) => {
        const isImage = file.type.startsWith('image/');
        const isSizeLimit = file.size / 1024 /1024 < 10;
        const allowedTypes = ['image/jpg','image/jpeg', 'image/png', 'image/gif', 'image/webp'];
        const isAllowedType = allowedTypes.includes(file.type);

        if (!isImage) {
            MessagePlugin.error('仅支持上传图片文件');
            return false;
        }
        if (!isSizeLimit) {
          MessagePlugin.error('图片大小不能超过10MB');
          return false;
        } 
        if (!isAllowedType) {
            MessagePlugin.error('仅支持 JPG、PNG、GIF 和 WEBP 格式的图片');
            return false;
        }
        return true;
       
    };

    // 上传图片成功处理
    const onUploadSuccess = (response, file) => {
        const imageUrl = response.url || file.url;
        if (imageUrl) {
            formData.image.push({ 
                url: imageUrl,
                raw: file.raw, 
                name: file.name,
            });
            MessagePlugin.success('图片上传成功');
        } else {
          console.error('无法获取上传图片的URL', response, file);
          MessagePlugin.error('图片上传失败，请重试');
        }
    };

    // 上传图片失败处理
    const onUploadFail = (response, file) => {
        console.error('图片上传失败:', response);
        MessagePlugin.error('图片上传失败，请重试');
    };


    /**
     * 提交表单事件
     */
     const submitForm = async () => {
         try {
             if (!validateForm()) { return; }
             const formDataToSend = new FormData();
     
             // 更新营地基础信息
             formDataToSend.append('name', formData.name.trim());
             formDataToSend.append('camp_type', JSON.stringify(formData.campType));
             formDataToSend.append('price', formData.price !== '' && formData.price !== null && formData.price !== undefined ? parseFloat(formData.price) : 0);
             formDataToSend.append('open_date', formData.openDate || '');
             formDataToSend.append('start_time', formData.openTime[0]);
             formDataToSend.append('end_time', formData.openTime[1]);
             formDataToSend.append('latitude', parseFloat(formData.latitude));
             formDataToSend.append('longitude', parseFloat(formData.longitude));
             formDataToSend.append('phone', formData.phone || '');
             formDataToSend.append('price_desc', formData.priceDesc || '');
             formDataToSend.append('is_on_site', formData.isOnSite);
             formDataToSend.append('is_active', formData.isActive);
             
             // 更新营地标签
             formDataToSend.append('camp_tag', JSON.stringify(formData.campTag));
     
             // 处理图片数据
             // 保留的现有图片URL
             const existingImageUrls = formData.image
                 .filter(img => img.status === 'success' && img.url && !img.raw)
                 .map(img => img.url);
             // 现有图片URL传给后端
             formDataToSend.append('existing_image', JSON.stringify(existingImageUrls));
             
             //添加新上传的图片文件
             formData.image
                 .filter(img => img.raw instanceof File)
                 .forEach(img => {
                     formDataToSend.append('image', img.raw);
                 });
     
             // 更新营地评分
             formDataToSend.append('base_rate', formData.rate);
             formDataToSend.append('base_env_rate', formData.envRate);
             formDataToSend.append('base_facility_rate', formData.facilityRate);
             formDataToSend.append('base_experience_rate', formData.experienceRate);
     
             // 更新营地设施
             const facilityData = [];
             for (const [title, value] of Object.entries(formData.facility)) {
                 if (value) {
                     const facility = facilityList.value.find(f => f.title === title);
                     if (facility) {
                     facilityData.push({
                             facility_id: facility.id,
                             facility_name: facility.title,
                             facility_content: Array.isArray(value) ? value.join(',') : value,
                             facility_desc: formData.facility[title + '_desc'] || '',
                             facility_group: facility.group_name,
                             facility_group_id: facility.group_id,
                         });
                     }
                 }
             }
             formDataToSend.append('facility', JSON.stringify(facilityData));
     
             console.log('准备提交的数据:', Object.fromEntries(formDataToSend));
     
             // 发送API请求
             const response = await campAPI.updateCamp(route.params.id, formDataToSend);
             
             MessagePlugin.success('营地更新成功');
             router.push({
                 path: '/camp/camp-admin',
                 query: { refresh: 'true' } 
             });
         } catch (error) {
             console.error('营地更新失败:', error);
             MessagePlugin.error(`更新营地失败: ${error.message || '请重试'}`);
         }
     };

     /**
     * 验证表单
     */
    const validateForm = () => {
        if (!formData.name.trim()) {
            MessagePlugin.error('请输入营地名称');
            return false;
        }

        if (formData.campType.length === 0) {
            MessagePlugin.error('请选择营地类型');
            return false;
        }

        if (!formData.location.trim()) {
            MessagePlugin.error('请输入营地位置');
            return false;
        }

        if (formData.openDate.length === 0) {
            MessagePlugin.error('请选择开放日期');
            return false;
        }

        if (!formData.openTime[0] || !formData.openTime[1]) {
            MessagePlugin.error('请选择营业时间');
            return false;
        }

        if (formData.price === '' || formData.price === null || formData.price === undefined) {
            MessagePlugin.error('请输入营地价格');
            return false;
        }

        const price = parseFloat(formData.price);
        if (isNaN(price) || price < 0) {
            MessagePlugin.error('营地价格不能为负数');
            return false;
        }

        if (price > 999999.99) {
            MessagePlugin.error('营地价格最大999999.99');
            return false;
        }

        if (formData.isOnSite === null || formData.isOnSite === undefined) {
            MessagePlugin.error('请选择是否进行实地认证');
            return false;
        }

        if (formData.image.length === 0) {
            MessagePlugin.error('请上传营地图片');
            return false;
        }

        if (formData.image.length > 30) {
            MessagePlugin.error('最多只能上传30张图片');
            return false;
        }

        // 验证评分
        const validateRate = (rate, name) => {
            if (!rate || isNaN(parseFloat(rate))) {
                MessagePlugin.error(`请输入${name}评分`);
                return false;
            }
            const rateValue = parseFloat(rate);
            if (rateValue < 0 || rateValue > 5) {
                MessagePlugin.error(`${name}评分必须在 0-5 之间`);
                return false;
            }
            return true;
        };

        if (!validateRate(formData.envRate, '环境') ||
            !validateRate(formData.facilityRate, '设施') ||
            !validateRate(formData.experienceRate, '体验')) {
            return false;
        }

        // 验证必填的设施信息
        for (const facility of facilityList.value) {
                if (facility.is_required) {
                    const value = formData.facility[facility.title];
                    if (!value || (Array.isArray(value) && value.length === 0)) {
                        MessagePlugin.error(`请选择${facility.title}`);
                        return false;
                    }
                }
            }

        return true;
    };

    // 重置表单函数
    const resetForm = () => {
        Object.keys(formData).forEach(key => {
            if (Array.isArray(formData[key])) {
              formData[key] = [];
            } else if (typeof formData[key] === 'boolean') {
              formData[key] = false;
            } else {
              formData[key] = '';
            }
        });
    };

    /**
     * 取消处理
     */
    const handleCancel = () => {
        const dialog = DialogPlugin.confirm({
            header: '提示',
            body: '确定要取消编辑营地吗？未保存的数据将会丢失。',
            confirmBtn: '确定',
            cancelBtn: '取消',
            width: 400,
            onConfirm: () => {
                dialog.destroy(); 
                router.push('/camp/camp-admin');
            },
            onCancel: () => {
                dialog.destroy(); 
            }
        });
    };

    // 图片尺寸限制
    const sizeLimit = ref({ size: 10, unit: 'MB' });

    // 开放日期选项
    const openDateOption=[
        { label: '全部', checkAll: true },
        { label: '周一', value: '1' },
        { label: '周二', value: '2' },
        { label: '周三', value: '3' },
        { label: '周四', value: '4' },
        { label: '周五', value: '5' },
        { label: '周六', value: '6' },
        { label: '周日', value: '7' },
    ];


    const openMapPicker=()=>{
        window.open('https://lbs.amap.com/tools/picker', '_blank');
    };

    const descMaxLength="200"

</script>

<style scoped >
    @import"./camp-edit.css";
    @import"../../../components/style/style-content.css";
    @import"../../../components/style/style-add.css";
</style>